import {CookieHelper} from '../../Library/CookieHelper.js';

export class BottomNotification
{
    // Shows notification at bottom of the page, for example "accept cookies"
    constructor(elm)
    {
        if (CookieHelper.getCookie('cookie_eaten') === 'true') return;

        elm.classList.add('visible');

        let yesButton = elm.querySelector('button[type="submit"]');
        let closeButton = elm.querySelector('.close.icon-cross');
        if (yesButton) {
            yesButton.addEventListener('click', () => {
                CookieHelper.setCookie('cookie_eaten', 'true', 365);
                elm.hide();
            });
        }
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                elm.hide();
            });
        }
    }
}
